import { CustomOrderType } from './store/carts/CustomOrderType';

export const enum Resolutions {
  SMALL = 0,
  MEDIUM = 568,
  LARGE = 768,
  XLARGE = 1024,
  XXLARGE = 1280,
  XXXLARGE = 1440,
  XXXXLARGE = 1600,
  MAX = 1920
}

export enum Breakpoint {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  TABLET = 'tablet'
}

export enum AddressContext {
  DELIVERY = 'delivery',
  PAYMENT = 'payment'
}

export const pageSize: number = 60;
export const orderListPageSize: number = 5;
export const maxPaginationSiblings: number = 4;

// Keep in sync with Apollo (apollo/src/common/const.ts)
export const offerCategoryCode: string = '300';
export const rootCategoryCode: string = 'root';
export const brandsCategoryCode: string = 'brands';
export const subbrandsCategoryCode: string = 'subbrands';
export const brandCategoryCodePrefix: string = 'b_';
export const brandsFolderCategoryCodePrefix: string = 'bf_';
export const subBrandCategoryCodePrefix: string = 'sb_';
export const specialCategoryCodesSet: Set<string> = new Set<string>([
  rootCategoryCode,
  offerCategoryCode,
  brandsCategoryCode,
  subbrandsCategoryCode
]);

export const supportedCountryCodes: ReadonlyArray<string> = ['at', 'ch', 'de'];
export const maxNonDefaultWishlists: number = 6;
export const maxWishlistsImages: number = 6;

export enum CountryCodes {
  DE = 'DE',
  CH = 'CH',
  AT = 'AT',
  HR = 'HR',
  HU = 'HU',
  SI = 'SI',
  ES = 'ES',
  SK = 'SK'
}

export const cartsCookieCookieName: string = 'CARTS_COOKIE';
export const cookieVersionCookieName: string = 'cookie-consents_CV';
export const acceptedCookiesCookieName: string = 'cookie-consents_ACC';
export const searchHubSessionIdCookieName: string = 'SearchCollectorSession';
export const sessionCookieName: string = 'session';

export const anonymousUid: string = 'anonymous';
export const guestUid: string = 'guest';
export const customerUid: string = 'customer';

export const searchFiltersRouteParam: string = 'searchFilters';

export const productBadgesLimit: number = 2;
export const fallbackProductImage = {
  url: '/assets/no-image-product.png',
  height: 1024,
  width: 1024
};

export const oneSecondInMilliseconds: number = 1000;

export const centsConversionFactor: number = 100;
export const normalizeToCents = (value: number): number =>
  Math.round(value * centsConversionFactor);

export const minimumDefaultCartQuantity: number = 1;
export const maximumDefaultCartQuantity: number = 10;
export const defaultCartQuantityIncrement: number = 1;

export const deliveryIconPaths = {
  [CustomOrderType.HOME_DELIVERY]: '/assets/icons/local-shipping.svg',
  [CustomOrderType.COLLECT_AT_STORE]: '/assets/icons/storefront.svg'
};

export const packstationLabel = 'Packstation';
export const cartPath = '/cart/';
export const checkoutOnePagePath = '/checkout/';
export const checkoutLoginPath = '/checkout/login/';
export const loginRegisterPath = '/auth/login-register/';
export const checkoutConfirmationPath = '/checkout/confirmation/';
export const checkoutStepsStartPath = `${checkoutOnePagePath}?step=contact`;
export const checkoutOnePagePaymentPath = '/checkout/?step=payment';
export const myAccountPath = '/my-account/';
export const updateProfilePath = '/my-account/update-profile/';
export const emailVerifiedQueryParam = 'emailVerified';
// react-doctor-disable-next-line react-doctor/no-secrets-in-client-code
export const passwordResetQueryParam = 'passwordReset';
// react-doctor-disable-next-line react-doctor/no-secrets-in-client-code
export const passwordChangedQueryParam = 'passwordChanged';
// react-doctor-disable-next-line react-doctor/no-secrets-in-client-code
export const showPasswordResetQueryParam = 'showPasswordReset';
export const defaultWishlistSlug = 'default';
export const bstrLogoutCookieName = 'bstr-logout';
export const bstrLogoutRetUrlCookieName = 'bstr-logout-ret-url';
export const dailyDosesInfoAttributeId = 'tagesdosisInfo';

export const latLngByCountry: Record<string, { lat: number; lng: number }> = {
  AT: { lat: 47.5162, lng: 14.5501 },
  CH: { lat: 46.8182, lng: 8.2275 },
  DE: { lat: 51.1657, lng: 10.4515 },
  ES: { lat: 40.0, lng: -4.0 },
  HU: { lat: 47.1625, lng: 19.5033 },
  HR: { lat: 45.1, lng: 15.2 },
  SI: { lat: 46.1512, lng: 14.9955 },
  SK: { lat: 48.669, lng: 19.699 }
};

export const countryDomains: Record<string, string> = {
  DE: 'mueller.de',
  AT: 'mueller.at',
  CH: 'mueller.ch',
  ES: 'mueller.es',
  HU: 'mueller.co.hu',
  HR: 'mueller.hr',
  SI: 'mueller.si',
  SK: 'mueller.sk'
};

export const storefinderUrlByCountry: Record<string, string> = {
  AT: '/storefinder',
  CH: '/storefinder',
  DE: '/storefinder',
  ES: '/mis-tiendas',
  HU: '/mueller-uezletek',
  HR: '/moja-poslovnica',
  SI: '/poslovalnice',
  SK: '/moja-predajna'
};

export const numberOfFreeSamples = 2;

export const defaultPageCacheSeconds = 60 * 3;
export const defaultPdpPageCacheSeconds = 60;
